import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ className = "", ...props }) => {
  const [show, setShow] = useState(false);
  const testid = props["data-testid"];
  return (
    <div className="relative">
      <input {...props} type={show ? "text" : "password"} className={`${className} pr-11`} />
      <button
        type="button"
        onClick={() => setShow(!show)}
        data-testid={testid ? `${testid}-toggle` : undefined}
        aria-label={show ? "Nascondi password" : "Mostra password"}
        className="absolute right-3.5 top-1/2 -translate-y-1/2 text-purple-300/50 hover:text-amber-300 transition-colors"
      >
        {show ? <EyeOff className="w-[18px] h-[18px]" /> : <Eye className="w-[18px] h-[18px]" />}
      </button>
    </div>
  );
};
